<template>
  <div class="content" style="display: flex;">
    <div class="login-header">
      <div class="icon-qnap c-wh"></div>
    </div>
    <div class="login-page">
      <div class="login-container">
        <div class="intro">
          <loginImg class="login-img"/>
          <div class="desc">
            <div class="title">{{$t('login.title')}}</div>
            <div class="content">{{$t('login.slogan')}}</div>
          </div>
        </div>
        <div class="login">
          <div class="div-account-panel">
            <div class="div-relative">
              <div class="title">{{$t('login.username')}}</div>
              <input ref="account" v-model="account" @keyup.enter="onLoginClick" type="text" class="account-username" :placeholder="$t('login.nameText')">
            </div>
            <div class="div-relative">
              <div class="title">{{$t('login.password')}}</div>
              <input ref="password" v-model="password" @keyup.enter="onLoginClick" :type="showPassword" class="account-user-password" :placeholder="$t('login.passwordText')">
              <!-- <span class="div-password-eye" @click="onShowPasswordClick()"></span> -->
            </div>
            <div>
              <div>
                <label class="div-label checkbox" :class="{checked: rememberMe===true}" @click="onRememberMeClick">{{$t('login.rememberMe')}}</label>
              </div>
            </div>
            <div class="div-err-msg" :class="{ show: error, hide: !error }">{{error}}</div>
          </div>
          <div class="div-btn">
            <button class="div-btn-login" :title="$t('login.qswBtnTips')" @click="onLoginClick">{{$t('login.loginBtn')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions,
  mapState,
  mapMutations
} from 'vuex'
import Encrypt from '../util/encrypt'
import loginImg from '../assets/svg/login_img.svg'
export default {
  name: 'Login',
  components: {
    loginImg
  },
  data () {
    return {
      account: 'admin',
      password: '',
      rememberMe: false,
      secureLogin: false,
      showPassword: 'password',
      localStorageAccount: 'qsw_account',
      localStorageRememberMe: 'qsw_rememberme',
      error: '',
      buttonTitle: '',
      mac: ''
    }
  },
  created: function () {
    this.rememberMe =
        this.$localStorage.get(this.localStorageRememberMe) === 'true'
    if (this.rememberMe) {
      const account = this.$localStorage.get(this.localStorageAccount)
      const password = this.$localStorage.get(this.localStoragePassword)
      if (account) {
        this.account = Encrypt.ezDecode(account)
      }
      if (password) {
        this.password = Encrypt.ezDecode(password)
      }
    }
    this.buttonTitle = this.$t('login.qswBtnTips')
  },
  mounted: function () {
    this.$refs.password.focus()
    this.$refs.password.select()
  },
  methods: {
    onLoginClick: async function () {
      let me = this
      let encrypt = Encrypt.ezEncode(this.account + ':' + this.password)
      this.$localStorage.set(this.localStorageRememberMe, this.rememberMe)
      let user = {
        username: this.account,
        pwd: this.password ? Encrypt.ezEncode(this.password) : '',
        auth: encrypt
      }
      me.$store.commit('updateFullLoadingStatus', true)
      await this.postLogin({user})
        .then(res => {
          this.$log.debug(res)
          if (this.rememberMe) {
            this.$localStorage.set(
              this.localStorageAccount,
              Encrypt.ezEncode(this.account)
            )
            this.$localStorage.set(
              this.localStoragePassword,
              Encrypt.ezEncode(this.password)
            )
          }
          this.getSystemInfo()
            .then((res) => {
              if (res.data && res.data.error_code === 200 && res.data.result) {
                let temp = res.data.result.mac.split(':')
                let tempPwd = ''
                for (let idx = 0; idx < temp.length; idx++) {
                  tempPwd = tempPwd + temp[idx]
                }
                this.error = ''
                if (this.password === tempPwd) {
                  this.openModal('pwd-update-modal')
                  this.$modal.show('pwd-update-modal')
                  this.password = ''
                } else {
                  setTimeout(function () {
                    me.$store.commit('login')
                    me.$router.push({
                      name: 'dashboard'
                    })
                    me.$store.commit('updateMenu', {menu: 'dashboard'})
                    me.$store.commit('updateFullLoadingStatus', false)
                  }, 0)
                }
              }
            }).catch((err) => {
              this.$log.error(err)
            })
        })
        .catch(error => {
          me.$store.commit('updateFullLoadingStatus', false)
          this.$log.info('error message back')
          if (!error.response) {
            this.error = 'Network error'
          } else if (error.response && (error.response.data.error_code === 401 || error.response.status === 401)) {
            this.error = this.$t('login.authorizedError')
            if (error.response.data.error_message.includes('busy')) {
              this.$store.commit('updateTimeoutWinStatus', {status: true, type: 'busy'})
              this.error = ''
            }
          } else {
            this.error = error.message
          }
          this.$log.debug(this.error)
          this.$router.push({
            name: 'login'
          })
          this.$store.commit('logout')
        })
    },
    onShowPasswordClick: function () {
      this.showPassword === 'password' ? (this.showPassword = 'text') : (this.showPassword = 'password')
    },
    onUsernameClick: function () {
      this.account = ''
    },
    onRememberMeClick: function () {
      this.rememberMe = !this.rememberMe
    },
    onSecureMeClick: function () {
      this.secureLogin = !this.secureLogin
    },
    ...mapActions([
      'postLogin', 'getSystemInfo'
    ]),
    ...mapMutations([
      'openModal', 'closeModal'
    ])
  },
  computed: {
    ...mapState({
      currentUser: state => state.module.currentUser,
      sysinfo: state => state.module.sysinfo,
      showErrors: state => state.module.showErrors
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import '../assets/scss/login.scss';
</style>



// WEBPACK FOOTER //
// src/components/Login.vue